import { IContentLanguage } from '@shared/models/multilanguage-model';
import { ILanguage } from '../languages-service/languages-model';
import { IEventMailContent } from '@shared/models/eventmail-content.model';

export interface IInvitationEmail {
    id: string;
    fromDate: Date;
    toDate: Date;
    rsvpWithin: number;
    invitationType: number;
    languages: ILanguage[];
    subjects: IContentLanguage[];
    contentsTop: IEventMailContent[];
    contentsBottom: IEventMailContent[];
    attachements: File[];
    currentAttachements: string[];
    smsContents: IContentLanguage[];
    smsEnabled: boolean;
    showLogo: boolean;
    showBanner: boolean;
    showRsvp: boolean;
    showRegistrationButton: boolean;
    showInfoButton: boolean;
    showContentBottom: boolean;
    showDetail: boolean;
    showContact: boolean;
    showCalendar: boolean;
    enableBcc: boolean;
    languageId: string;
    userIds: string[];
    rsvpWithinDate: Date;
}

export interface IConfirmationEmail {
    id: string;
    languages: ILanguage[];
    subjects: IContentLanguage[];
    contentsTop: IEventMailContent[];
    contentsBottom: IEventMailContent[];
    attachements: File[];
    currentAttachements: string[];
    showLogo: boolean;
    showBanner: boolean;
    showRegistrationButton: boolean;
    showInfoButton: boolean;
    showWebinarButton: boolean;
    showTicketButton: boolean;
    showContentBottom: boolean;
    showDetail: boolean;
    showContact: boolean;
    showCalendar: boolean;
    showRegistration: boolean;
    enableBcc: boolean;
    confirmationSenderType: number;
    languageId: string;
    userIds: string[];
    showGalleryButton: boolean;
}

export interface IReminderEmail {
    id: string;
    reminderWithin: number;
    languages: ILanguage[];
    subjects: IContentLanguage[];
    contentsTop: IEventMailContent[];
    contentsBottom: IEventMailContent[];
    attachements: File[];
    currentAttachements: string[];
    smsContents: IContentLanguage[];
    smsEnabled: boolean;
    showLogo: boolean;
    showBanner: boolean;
    showRsvp: boolean;
    showRegistrationButton: boolean;
    showInfoButton: boolean;
    showContentBottom: boolean;
    showDetail: boolean;
    showContact: boolean;
    showCalendar: boolean;
    enableBcc: boolean;
    languageId: string;
    userIds: string[];
}

export interface IInternalReminderEmail {
    id: string;
    reminderWithin: number;
}

export interface IWelcomeEmail {
    id: string;
    daysBefore: number;
    languages: ILanguage[];
    subjects: IContentLanguage[];
    contentsTop: IEventMailContent[];
    contentsBottom: IEventMailContent[];
    attachements: File[];
    currentAttachements: string[];
    smsContents: IContentLanguage[];
    smsEnabled: boolean;
    showLogo: boolean;
    showBanner: boolean;
    showRegistrationButton: boolean;
    showInfoButton: boolean;
    showWebinarButton: boolean;
    showTicketButton: boolean;
    showContentBottom: boolean;
    showDetail: boolean;
    showContact: boolean;
    showCalendar: boolean;
    showRegistration: boolean;
    enableBcc: boolean;
    welcomeSenderType: number;
    languageId: string;
    userIds: string[];
    showGalleryButton: boolean;
}

export interface IThankYouEmail {
    id: string;
    daysAfter: number;
    languages: ILanguage[];
    subjects: IContentLanguage[];
    contentsTop: IEventMailContent[];
    contentsBottom: IEventMailContent[];
    attachements: File[];
    currentAttachements: string[];
    showLogo: boolean;
    showBanner: boolean;
    showSurveyButton: boolean;
    showContentBottom: boolean;
    showDetail: boolean;
    showContact: boolean;
    enableBcc: boolean;
    thankYouSenderType: number;
    languageId: string;
    userIds: string[];
    showGalleryButton: boolean;
    showDocumentButton: boolean;
}

export interface IPaymentDocumentEmail {
    id: string;
    daysAfter: number;
    languages: ILanguage[];
    subjects: IContentLanguage[];
    contentsTop: IEventMailContent[];
    contentsBottom: IEventMailContent[];
    attachements: File[];
    currentAttachements: string[];
    showLogo: boolean;
    showBanner: boolean;
    showSurveyButton: boolean;
    showContentBottom: boolean;
    showDetail: boolean;
    showContact: boolean;
    enableBcc: boolean;
    paymentDocumentSenderType: number;
    languageId: string;
    userIds: string[];
    showGalleryButton: boolean;
}

export interface IAdHocEmail {
    id: string;
    languages: ILanguage[];
    subjects: IContentLanguage[];
    contentsTop: IEventMailContent[];
    contentsBottom: IEventMailContent[];
    attachements: File[];
    sendDate: Date;
    sendNow: boolean;
    targetGroupType: number;
    locationDateTimeIds: string[];
    currentAttachements: string[];
    showLogo: boolean;
    showBanner: boolean;
    showRsvp: boolean;
    showRegistrationButton: boolean;
    showInfoButton: boolean;
    showWebinarButton: boolean;
    showSurveyButton: boolean;
    showTicketButton: boolean;
    showContentBottom: boolean;
    showDetail: boolean;
    showContact: boolean;
    showCalendar: boolean;
    showRegistration: boolean;
    enableBcc: boolean;
    adHocSenderType: number;
    languageId: string;
    userIds: string[];
    name: string;
    showGalleryButton: boolean;
    showDocumentButton: boolean;
}

export interface ISaveTheDateEmail {
    id: string;
    languages: ILanguage[];
    subjects: IContentLanguage[];
    contentsTop: IEventMailContent[];
    contentsBottom: IEventMailContent[];
    sendDate: Date;
    sendNow: boolean;
    attachements: File[];
    currentAttachements: string[];
    showLogo: boolean;
    showBanner: boolean;
    showDetail: boolean;
    showContact: boolean;
    showCalendar: boolean;
    enableBcc: boolean;
    languageId: string;
    userIds: string[];
}
